import { createContext, useEffect, createRef } from 'react'
import { createPortal } from 'react-dom'
import styled from '@emotion/styled'

const Overlay = styled.div`
  background-color: ${({ theme }) => theme.colors.overlay};
  height: 100vh;
  left: 0;
  padding-top: 2%;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 2000;
`

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-height: 700px;
  max-width: ${(props) => props.maxWidth};
  overflow: hidden;
  padding: 1.5rem 2rem 2rem 2rem;
  position: relative;
  width: 95vw;
`

const modalContext = createContext()

const Modal = ({ children, maxWidth, onClose }) => {
  useEffect(() => {
    const keyListener = (e) => {
      const listener = keyListenersMap.get(e.keyCode)
      return listener && listener(e)
    }

    if (typeof window !== 'undefined') {
      document.addEventListener('keydown', keyListener)
      return () => document.removeEventListener('keydown', keyListener)
    } else {
      return false
    }
  })

  const modalRef = createRef()

  const handleTabKey = (e) => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    )
    const firstElement = focusableModalElements[0]
    const lastElement =
      focusableModalElements[focusableModalElements.length - 1]

    if (!e.shiftKey && document.activeElement !== firstElement) {
      firstElement.focus()
      return e.preventDefault()
    }

    if (e.shiftKey && document.activeElement !== lastElement) {
      lastElement.focus()
      e.preventDefault()
    }
  }

  const keyListenersMap = new Map([
    [27, onClose],
    [9, handleTabKey],
  ])

  if (typeof window !== 'undefined') {
    return createPortal(
      <Overlay role="dialog" aria-modal="true" onClick={onClose}>
        <Container maxWidth={maxWidth} ref={modalRef}>
          <modalContext.Provider value={{ onClose }}>
            {children}
          </modalContext.Provider>
        </Container>
      </Overlay>,
      document.body
    )
  } else {
    return null
  }
}

Modal.defaultProps = {
  maxWidth: '600px',
}

export default Modal
